import React from 'react';

import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Video from '../../components/Video';

import ptx1 from "../../images/contents/ptx1.jpg"
import ptx2 from "../../images/contents/ptx2.jpg"
import ptx3 from "../../images/contents/ptx3.jpg"
import ptx4 from "../../images/contents/ptx4.jpg"

class Filmmakers extends React.Component {

  constructor (props) {
    super(props);
    this.imageClick = this.imageClick.bind(this);
  }

  imageClick(event) {
    event.preventDefault();
    let url = "https://player.vimeo.com/video/" + event.target.getAttribute('alt')
    document.getElementById('iframe').setAttribute("src", url)
    document.getElementById('video').classList.toggle("hidden")
  }

  render () {

    return (

      <React.Fragment>

        <Video id="video" />

        <div className="main maker">

          <Header />

          <div className="content">

            <h2 className="title">SISTEMA<br/>PTx</h2>

            <div className="maker_wrapper">
              <div className="maker_container"><img key="343301188" src={ptx1} className="maker_image" video="https://vimeo.com/343301188" onClick={this.imageClick} alt="343301188"/></div>
              <div className="maker_container"><img key="343302453" src={ptx2} className="maker_image" video="https://vimeo.com/343302453" onClick={this.imageClick} alt="343302453"/></div>
              <div className="maker_container"><img key="343316072" src={ptx3} className="maker_image" video="https://vimeo.com/343316072" onClick={this.imageClick} alt="343316072"/></div>
              <div className="maker_container"><img key="343317415" src={ptx4} className="maker_image" video="https://vimeo.com/343317415" onClick={this.imageClick} alt="343317415"/></div>
            </div>

          </div>

          <Footer />

        </div>

      </React.Fragment>

    );
  }
}

export default Filmmakers;